import { FC, useState } from "react";
import { Alert, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { CounterpartyForm } from "../counterpartyForm";
import { useSubmitOnboardingRequest } from "../../admin/onboardingRequests/queries";

export const RequestNewCounterparty: FC = () => {
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const submitRequest = useSubmitOnboardingRequest({
    onSuccess: () =>
      navigate("/tradingcounterparties/my-requests", {
        state: { submitted: true }
      }),
    onError: (error) => setErrorMessage(error.message)
  });

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: 1080,
        marginX: "auto",
        overflowY: "auto",
        paddingBottom: 3
      }}
    >
      {errorMessage && (
        <Alert severity="error" sx={{ marginTop: 2 }}>
          {errorMessage}
        </Alert>
      )}
      <CounterpartyForm
        onSubmit={(payload) => {
          setErrorMessage(null);
          submitRequest.mutate(payload);
        }}
        submitting={submitRequest.isPending}
        submitLabel="Submit request"
        onCancel={() => navigate("/tradingcounterparties")}
      />
    </Box>
  );
};
